var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21558 18.8337L10.8999 18.8142L23.3068 6.45271C23.7937 5.96291 24.0616 5.31244 24.0616 4.62051C24.0616 3.92857 23.7937 3.2781 23.3068 2.78831L21.2639 0.733236C20.2901 -0.246356 18.5911 -0.241173 17.625 0.729349L5.21558 13.0935V18.8337ZM19.4425 2.56544L21.4893 4.61662L19.4322 6.6665L17.3893 4.61273L19.4425 2.56544ZM7.79176 14.1741L15.5589 6.43456L17.6018 8.48963L9.83596 16.2266L7.79176 16.2331V14.1741Z",
    fill: "#E4151B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63868 24.0004H20.6719C22.0927 24.0004 23.2481 22.8381 23.2481 21.4089V10.1772L20.6719 12.7688V21.4089H6.70647C6.67298 21.4089 6.6382 21.4218 6.60471 21.4218C6.5622 21.4218 6.5197 21.4102 6.4759 21.4089H2.63868V3.26827H11.4582L14.0344 0.676758H2.63868C1.21792 0.676758 0.0625 1.83905 0.0625 3.26827V21.4089C0.0625 22.8381 1.21792 24.0004 2.63868 24.0004Z",
    fill: "#E4151B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostEdit);
export default __webpack_public_path__ + "static/media/postEdit.57a7fc3276597be8bdc098addb23804f.svg";
export { ForwardRef as ReactComponent };